import axios from 'axios';
import { PAGING_DEFAULT } from '../constants/constants';
import { IParamsRequest } from '../interfaces/IAction';
import { IApiResponse } from '../interfaces/IApiResponse';
import urls from './urls';
import { generateParams } from './userApi';

class NewFeedApi {
  static getPageHome(params: IParamsRequest): Promise<IApiResponse<any>> {
    const queryString = generateParams({
      ...params,
      Size: params.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    });
    const url = `${urls.GET_USER_PAGE_HOME}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getPageHomeWithPinnedContent(params: IParamsRequest): Promise<IApiResponse<any>> {
    const queryString = generateParams({
      ...params,
      Size: params.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    });
    const url = `${urls.GET_USER_PAGE_HOME_WITH_PINNED_CONTENT}${queryString ? '?' : ''}${queryString}`;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getActivitySumaryUser(): Promise<IApiResponse<any>> {
    const url = urls.GET_ACTIVITYSUMMARY_USERS;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getDateFinderCount(): Promise<IApiResponse<any>> {
    const url = urls.GET_DATE_FINDER_COUNT;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getActiveUsersCount(): Promise<IApiResponse<any>> {
    const url = urls.GET_ACTIVE_USERS_COUNT;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getProspectsSummaryCount(): Promise<IApiResponse<any>> {
    const url = urls.GET_PROSPECTS_SUMMARY_COUNT;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getListCurrentCompetitions(): Promise<IApiResponse<any>> {
    const url = urls.GET_CURRENT_COMPETITIONS;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getRecent(): Promise<IApiResponse<any>> {
    const url = urls.GET_RECENT;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getAnnouncementBanner(): Promise<IApiResponse<any>> {
    const url = urls.GET_USER_ANNOUNCEMENT_BANNER;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default NewFeedApi;
